import React, { useState, useEffect } from 'react';
import './Header.css';
import logo from "../../template/images/finlabs-logo.png";

const Header = () => {
  const [showProducts, setShowProducts] = useState(false);
  const [showServices, setShowServices] = useState(false);
  const [showKnowledge, setShowKnowledge] = useState(false);
  const [showNav, setShowNav] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1024);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = (menuSetter, currentState) => {
    if (isMobile) {
      menuSetter(!currentState);
    }
  };

  return (
    <div className="header-wrapper">
      <div className="top-bar">
        <div className="social-icons">
          <a href="https://www.facebook.com/finlabsind" aria-label="Facebook" className="icon" target="_blank"><i className="fab fa-facebook-f"></i></a>
          <a href="https://x.com/IndiaFinlabs" aria-label="Twitter" className="icon" target="_blank"><i className="fab fa-twitter"></i></a>
          <a href="https://www.instagram.com/finlabsindia/" aria-label="Instagram" className="icon" target="_blank"><i className="fab fa-instagram"></i></a>
          <a href="https://www.linkedin.com/company/14438243/" aria-label="LinkedIn" className="icon" target="_blank"><i className="fab fa-linkedin-in"></i></a>
          <a href="https://www.youtube.com/@finlabsindia7860" aria-label="Youtube" className="icon" target="_blank" style={{ backgroundColor: '#d51212' }}><i className="fab fa-youtube"></i></a>
        </div>
        <div className="contact-email">
          <i className="fas fa-envelope"></i>
          <span><a href="mailto:info@finlabsindia.com" className="contact-link">info@finlabsindia.com</a></span>
        </div>
      </div>

      <div className="main-header">
        <div className="logo">
          <a href="https://finlabsindia.org/"><img src={logo} alt="FinLabs India Logo" /></a>
        </div>

        <div className="hamburger" onClick={() => setShowNav(!showNav)}>
          <div></div>
          <div></div>
          <div></div>
        </div>

        <nav className={`nav-links ${showNav ? 'show' : ''}`}>
          {/* Products Dropdown */}
          <div
            className="dropdown"
            onMouseEnter={() => !isMobile && setShowProducts(true)}
            onMouseLeave={() => !isMobile && setShowProducts(false)}
            onClick={() => toggleMenu(setShowProducts, showProducts)}
          >
            <a href="https://finlabsindia.org/products/">Products &#9662;</a>
            {showProducts && (
              <div className="sub-menu">
                <a href="https://finlabsindia.org/finexa-wealth-management-platform/">Finexa</a>
                <a href="https://finlabsindia.org/engaging-and-outcome-oriented-training-with-learngenie/">Learngenie</a>
                <a href="https://finlabsindia.org/fiscus/">Fiscus</a>
                <a href="https://finlabsindia.org/finexagennxt/">FinexaGenNxT</a>
              </div>
            )}
          </div>

          <div className="dropdown">
            <a href="https://finlabsindia.org/solutions/">Solutions</a>
          </div>

          {/* Services Dropdown */}
          <div
            className="dropdown"
            onMouseEnter={() => !isMobile && setShowServices(true)}
            onMouseLeave={() => !isMobile && setShowServices(false)}
            onClick={() => toggleMenu(setShowServices, showServices)}
          >
            <a href="https://finlabsindia.org/finexa-wealth-management-platform/">Services &#9662;</a>
            {showServices && (
              <div className="sub-menu">
                <a href="https://finlabsindia.org/finexa-wealth-management-platform/">Technology Consulting</a>
                <a href="https://finlabsindia.org/technology-implementation/">Technology Implementation</a>
                <a href="https://finlabsindia.org/managed-services/">Managed Services</a>
              </div>
            )}
          </div>

          <div className="dropdown">
            <a href="https://finlabsindia.org/careers/">Careers</a>
          </div>

          {/* Knowledge Centre Dropdown */}
          <div
            className="dropdown"
            onMouseEnter={() => !isMobile && setShowKnowledge(true)}
            onMouseLeave={() => !isMobile && setShowKnowledge(false)}
            onClick={() => toggleMenu(setShowKnowledge, showKnowledge)}>
            <a href="https://finlabsindia.org/knowledge-centre/">Knowledge Centre &#9662;</a>
            {showKnowledge && (
              <div className="sub-menu">
                <a href="https://finlabsindia.org/summariwise/">Summariwise</a>
                {/* Financial Hub with nested submenu */}
                <div className="dropdown-sub">
                  <a
                    href="#"
                    onClick={(e) => isMobile && e.preventDefault()}
                    className="has-submenu"
                  >
                    Financial Hub &#9656;
                  </a>
                  <div className="sub-menu-right">
                    <a href="https://finlabsindia.org/ff11/">FF11</a>
                    <a href="https://finlabsindia.org/financial-calculators-2/">Financial Calculators</a>
                    <a href="https://finlabsweb.finlabsindia.org/Quiz">Finance Quiz</a>
                  </div>
                </div>
                <a href="https://finlabsindia.org/blog/">Blog</a>
                <a href="https://finlabsindia.org/infographics/">Infographics</a>
                <a href="https://finlabsindia.org/download/">Download</a>
              </div>
            )}
          </div>
        </nav>

        <div className="header-actions">
          <i className="fas fa-search search"></i>
          <button className="talk-btn"><a href="https://finlabsindia.org/contact-us/">Talk to us</a></button>
        </div>
      </div>
    </div>
  );
};

export default Header;
